import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";
import { FaGreaterThan } from "react-icons/fa6";
import AdvServiceMainSection from "../../PageElements/AdvServiceBookingPageElement/AdvServiceMainSection";

export default function AdvServiceBooking() {
    return (
        <>
            <ServiceHeader
                childClass="pathologBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15}/>Adv Service Booking</>}
                title="Adv Service Booking"
            />

            
            <AdvServiceMainSection/>
        </>
    )
}